const INVITE_KEY = 'adop.invite.token';

/** Remembers an invite token across the Google OAuth redirect. */
export function rememberInviteToken(token: string): void {
  try {
    window.sessionStorage.setItem(INVITE_KEY, token);
  } catch {
    // sessionStorage can be unavailable; the email link still works.
  }
}

/** Reads the stored invite token without clearing it (retryable). */
export function peekInviteToken(): string | null {
  try {
    return window.sessionStorage.getItem(INVITE_KEY);
  } catch {
    return null;
  }
}

/** Clears the stored invite token after a successful accept. */
export function clearInviteToken(): void {
  try {
    window.sessionStorage.removeItem(INVITE_KEY);
  } catch {
    // ignore
  }
}
